import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'signup-retailer_sign_up_complete-action_unknown';
/**
 * A retail user has successfully created their account
 */
export function trackSignupRetailerSignUpComplete(retailer_token, pixelCustomDataParams) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        facebookPixelEvent: 'CompleteRegistration',
        googleTagManagerEvent: 'if-sign-up',
        pixelCustomDataParams: pixelCustomDataParams,
        parameters: { retailer_token },
    });
}
